import { getNationalNumber } from '@/helpers';
import { isMaskedValue } from '@/utils/validation';
import {
  Box,
  Typography,
  Grid,
  Paper,
  makeStyles,
  useMediaQuery,
} from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { isValidPhoneNumber, parsePhoneNumber } from 'libphonenumber-js';
import moment from 'moment';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#e2f2ffb3',
    borderRadius: 16,
    padding: theme.spacing(3, 2),
    width: '25vw',
    boxShadow: 'none',
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 1),
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    gap: 8,
  },
  label: {
    color: '#666',
    minWidth: 110,
    fontSize: 15,
    fontWeight: 400,
    [theme.breakpoints.down('xs')]: {
      minWidth: 90,
      fontSize: 14,
    },
  },
  value: {
    color: '#222',
    fontSize: 16,
    fontWeight: 500,
    wordBreak: 'break-word',
    [theme.breakpoints.down('xs')]: {
      fontSize: 15,
    },
  },
  row: {
    marginBottom: theme.spacing(1),
  },
}));

const InfoRow = ({ label, value }) => {
  const classes = useStyles();
  return (
    <Grid container alignItems="flex-start" className={classes.row}>
      <Grid item xs={5} sm={4} md={5} className={classes.label}>
        {label}
      </Grid>
      <Grid
        item
        xs={7}
        sm={8}
        md={7}
        className={classes.value}
        style={{ color: value === 'None' ? '#999999' : '#222222' }}
      >
        {value}
      </Grid>
    </Grid>
  );
};

const PatientInfoCard = ({ dataInfo }) => {
  const classes = useStyles();
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  return (
    <Paper className={classes.root} elevation={0}>
      <Box className={classes.header}>
        <PersonIcon style={{ color: '#666', fontSize: isMobile ? 22 : 26 }} />
        <Typography
          variant={isMobile ? 'h6' : 'h5'}
          style={{ fontWeight: 500, color: '#333' }}
        >
          Patient info
        </Typography>
      </Box>
      <InfoRow label="Name" value={dataInfo.paxInfo.fullName || 'None'} />
      <InfoRow
        label="ID number"
        value={dataInfo.paxInfo.identityNumber || 'None'}
      />
      <InfoRow
        label="Date of birth"
        value={
          dataInfo.paxInfo.dateOfBirth
            ? moment(dataInfo.paxInfo.dateOfBirth).format('DD/MM/YYYY')
            : 'None'
        }
      />
      <InfoRow
        label="Ethnicity"
        value={dataInfo.paxInfo.ethnicGroup || 'None'}
      />
      <InfoRow
        label="Phone number"
        value={
          /* parsePhoneNumber THROWS on anything it cannot parse, and this is
             called straight from render - a BE-masked number like "*****0879"
             took the whole screen down. Show masked values as they arrive and
             only parse what libphonenumber accepts. */
          isMaskedValue(dataInfo.paxInfo?.mobile)
            ? dataInfo.paxInfo.mobile
            : dataInfo.paxInfo?.mobile &&
              isValidPhoneNumber(
                dataInfo.paxInfo?.mobile,
                dataInfo.paxInfo?.countryCode
              )
            ? parsePhoneNumber(
                getNationalNumber(
                  dataInfo.paxInfo?.mobile,
                  dataInfo.paxInfo?.countryCode,
                  true
                )
              ).formatInternational()
            : 'None'
        }
      />
      <InfoRow label="Email" value={dataInfo.paxInfo?.email || 'None'} />
      <InfoRow label="Company" value={dataInfo?.companyName || 'None'} />
      <InfoRow label="Staff type" value={dataInfo?.staffType?.type || 'None'} />
      <InfoRow
        label="Lab number"
        value={dataInfo?.currentLabNumber?.slice(3) || 'None'}
      />
    </Paper>
  );
};

export default PatientInfoCard;
